export default __webpack_public_path__ + "static/media/vision-bg.88638807.mp4";